import Vue from 'vue';
import Router from 'vue-router';

// import views
import Login from './components/forms/LoginForm';
import Register from './components/forms/RegisterForm';
import Forgot from './components/forms/ForgotForm';
import SetPassword from './components/forms/SetPasswordForm';
import AutoLogin from './components/main/AutoLogin';

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/login/:id?/:state?',
            name: 'login',
            component: Login,
            meta: { title: 'Личный кабинет' },
        },
        {
            path: '/register/:id?/:state?',
            name: 'register',
            component: Register,
            meta: { title: 'Личный кабинет' },
        },
        {
            path: '/forgot',
            name: 'forgot',
            component: Forgot,
            meta: { title: 'Восстановление доступа' },
        },
        {
            path: '/reset-password',
            name: 'setPassword',
            component: SetPassword,
            meta: { title: 'Восстановление доступа' },
        },
        {
            path: '/autologin',
            name: 'autoLogin',
            component: AutoLogin,
            meta: {title: 'Вход в систему'},
        },
        {
            path: '/autologin.html',
            redirect: '/autologin',
        },
        {
            path: '*',
            redirect: '/login',
        },
    ],
});
